module.exports = __webpack_public_path__ + "img/UTCORA-2.3323665c.jpg";